import { Kopfleiste, Seitenkopf } from './Kopfleiste.js'
import { Fuss } from './Fuss.js'
import { useSeitenleben } from './bewegung.js'
import { Markenzeichen } from './Markenzeichen.js'
import { ANBIETER } from '../recht.js'

/**
 * Die Kontaktseite.
 *
 * Bewusst ohne Formular. Ein Formular verspricht, dass jemand die Eingabe
 * entgegennimmt und zuordnet – dafür braucht es einen Posteingang, eine
 * Zuständigkeit und eine Antwortfrist, die eingehalten wird. Solange das nicht
 * steht, ist eine E-Mail-Adresse ehrlicher: sie landet dort, wo sie gelesen
 * wird, und der Absender hat sie in seinem eigenen Postausgang stehen.
 *
 * Drei Blöcke in einer Karte, durch senkrechte Haarlinien getrennt, in der
 * Reihenfolge, in der jemand sie braucht: wie erreiche ich euch, wo seid ihr,
 * und – falls die Frage schon beantwortet ist – wo steht die Antwort.
 */
export function Kontakt({
  angemeldet,
  aufStart,
  aufPfad,
  aufAnmelden,
  aufStarten
}: {
  angemeldet: boolean
  aufStart: () => void
  aufPfad: (pfad: string) => void
  aufAnmelden: () => void
  aufStarten: () => void
}): JSX.Element {
  const leben = useSeitenleben<HTMLDivElement>()

  return (
    <div ref={leben} className="rp-glasseite">
      <Kopfleiste
        angemeldet={angemeldet}
        aufStart={aufStart}
        aufPfad={aufPfad}
        aufAnmelden={aufAnmelden}
        aufStarten={aufStarten}
      />

      <Seitenkopf
        augenbraue="Kontakt"
        titel="Nimm"
        hell="Kontakt auf."
        vorspann="Eine Frage? Schreib uns — wir antworten zügig."
      />

      <main className="rp-glas-mitte">
        <div className="rp-glas">
          <div className="rp-kt-karte">
            {/*
              Die Marke gross und bewegt – nicht der Roboter.

              Der Roboter ist das Maskottchen des Fussbereichs. Hier ist die
              Frage eine andere: mit wem habe ich es zu tun. Die Antwort
              darauf ist die Marke, und sie steht vor der Adresse, nicht
              daneben.
            */}
            <Markenzeichen />

            <div className="rp-kt-rechts">
              <div className="rp-kt-block">
                <p className="rp-glas-label">E-Mail</p>
                <a className="rp-glas-wert" href={`mailto:${ANBIETER.email}`}>
                  {ANBIETER.email}
                </a>
                <p>
                  Fragen zur Bedienung, zu den Paketen, zum Datenschutz und zu rechtlichen
                  Themen laufen über dieselbe Adresse.
                </p>
                {/*
                  «In der Regel innerhalb eines Werktags» – und nicht «innerhalb
                  von 24 Stunden». Das zweite klingt verbindlicher und ist es
                  nicht: es zählt Samstag und Sonntag mit und wird an einem
                  Freitagabend zwangsläufig gebrochen.
                */}
                <p className="rp-glas-notiz">
                  Wir antworten in der Regel innerhalb eines Werktags.
                </p>
              </div>

              <div className="rp-kt-block">
                <p className="rp-glas-label">Standort</p>
                <p className="rp-glas-wert">
                  {ANBIETER.sitz}, {ANBIETER.land}
                </p>
                <p>{ANBIETER.betreiber}</p>
                <p className="rp-glas-notiz">
                  Eine Postanschrift veröffentlichen wir, sobald die Gründung abgeschlossen
                  ist. Bis dahin ist die E-Mail der verbindliche Weg.
                </p>
              </div>

              <div className="rp-kt-block">
                <p className="rp-glas-label">Schneller als eine E-Mail</p>
                <p className="rp-glas-wert">Häufige Fragen</p>
                <p>
                  Was Raporto tut und was nicht, wie die Testphase läuft, wo die Daten liegen
                  – vierzehn Fragen mit Antworten, die nicht ausweichen.
                </p>
                <div className="rp-glas-knoepfe" style={{ justifyContent: 'flex-start' }}>
                  <button
                    type="button"
                    className="rp-kl-anmelden"
                    id="btn-kontakt-faq"
                    onClick={() => aufPfad('/faq')}
                  >
                    Zu den Fragen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Fuss aufPfad={aufPfad} />
    </div>
  )
}
